<template>
<span :class="classes">
	<font-awesome-icon
		class="teaming-checkbox__checked"
		:icon="['fas', 'check-square']"
		v-if="isChecked"
		@click="onCheckboxClick"
	/>
	<font-awesome-icon
		class="teaming-checkbox__unchecked"
		:icon="['far', 'square']"
		v-else
		@click="onCheckboxClick"
	/>
</span>
</template>

<script>

export default {
	name: "TeamingCheckbox",
	props: {
		className: {
			type: String,
			default: "",
		},
		name: {
			type: String,
			required: true,
		},
		isChecked: {
			type: Boolean,
			required: true,
		},
		isDisabled: {
			type: Boolean,
			default: false,
		},
		value: {
			type: String,
			default: "1",
		},
	},
	computed: {
		classes() {
			return {
				"teaming-checkbox": true,
				"teaming-checkbox--disabled": this.isDisabled,
				[ this.className ]: !!this.className,
			};
		},
	},
	methods: {
		onCheckboxClick() {
			if ( this.isDisabled ) {
				return;
			}
			const { name, isChecked, value, } = this;
			const payload = {
				isChecked: !isChecked,
				name,
				value,
			};
			this.$emit( "change", payload );
			this.$emit( "input", payload );
		},
	},
};
</script>

<style lang="scss" scoped>
.teaming-checkbox {
	cursor: pointer;
}

.teaming-checkbox--disabled {
	cursor: not-allowed;

	.teaming-checkbox__checked {
		color: $gray-500;
	}
}

.teaming-checkbox__checked {
	* {
		color: $blue-500;
	}
}

.teaming-checkbox__unchecked {
	* {
		color: $gray-200;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Common/TeamingCheckbox.vue